import { render, staticRenderFns } from "./templateSerialNumberScreen.vue?vue&type=template&id=167b1888&"
import script from "./templateSerialNumberScreen.vue?vue&type=script&lang=js&"
export * from "./templateSerialNumberScreen.vue?vue&type=script&lang=js&"
import style0 from "./templateSerialNumberScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports